import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router } from '@angular/router';
import { Auth } from './auth';

export const authGuard: CanActivateFn = (route: ActivatedRouteSnapshot) => {
  const authService = inject(Auth);
  const router = inject(Router);

  const expectedRoles = route.data['roles'] as string[];
  const userRole = authService.getUserDetails()?.role || null;
  const token = authService.getAccessToken();
  const hasToken = (token !== null && token !== undefined && token !== '');
  
  if (hasToken && userRole) {
    if (expectedRoles.length === 0 || expectedRoles.includes(userRole.toLowerCase())) {
      return true;
    }
  }

  return router.createUrlTree(['/unauthorized']);
};
